import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncorrectPermissions = _resolveComponent("IncorrectPermissions")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_FiscalYearReportSearch = _resolveComponent("FiscalYearReportSearch")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_FiscalYearReportTable = _resolveComponent("FiscalYearReportTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (!_ctx.canView)
        ? (_openBlock(), _createBlock(_component_IncorrectPermissions, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.canView)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "secondary",
                extended: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    custom: ""
                  }, {
                    default: _withCtx(({navigate}) => [
                      _createVNode(_component_v_btn, {
                        onClick: navigate,
                        icon: "",
                        class: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("mdi-arrow-left-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Drug Test Report by Program", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "mx-auto",
                "max-width": "100%",
                style: {"margin-top":"-60px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FiscalYearReportSearch, {
                    "is-searching": _ctx.isSearching,
                    onSearch: _ctx.getReportData,
                    onLoading: _cache[0] || (_cache[0] = val => _ctx.isLoading = val)
                  }, null, 8, ["is-searching", "onSearch"]),
                  (_ctx.isSearching)
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSearching && !_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("h2", {
                            class: "bg-secondary mt-3 pa-3",
                            style: {"text-align":"center"}
                          }, "Test Results", -1)),
                          _createVNode(_component_FiscalYearReportTable, {
                            title: "Drug Test Report by Program - Results",
                            filename: "ProgramDrugTestReportResults",
                            "is-searching": _ctx.isSearching,
                            "report-data": _ctx.testData,
                            headers: _ctx.testHeaders
                          }, null, 8, ["is-searching", "report-data", "headers"]),
                          _cache[4] || (_cache[4] = _createElementVNode("h2", {
                            class: "bg-secondary mt-3 pa-3",
                            style: {"text-align":"center"}
                          }, "Drugs Found", -1)),
                          _createVNode(_component_FiscalYearReportTable, {
                            title: "Drug Test Report by Program - Drugs Found",
                            filename: "ProgramDrugTestReportDrugs",
                            "is-searching": _ctx.isSearching,
                            "report-data": _ctx.drugData,
                            headers: _ctx.drugHeaders
                          }, null, 8, ["is-searching", "report-data", "headers"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}